/**************************************************
 * Nombre:       Dialogo_Habitaciones_Detalles
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logoRedondo from "../../../Recursos/logo_redondo.svg"
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import Formulario_Habitaciones_Detalles from "../../Formularios/Habitaciones/Formulario_Habitaciones_Detalles";
import {
    subirMultiplesImagenHostingArray
} from "../../../Servicios/AlmacenamientoHosting/subirMultiplesImagenHostingArray";
import {guardarFechaAct} from "../../../Servicios/BD/Actualizadores/guardarFechaAct";

const Dialogo_Habitaciones_Detalles = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad,
    } = useFormulario({valoresDefecto: datos})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'dos'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo datos')

        nuevoAviso({aviso: 'Subiendo imagenes'})

        let arr = await subirMultiplesImagenHostingArray({arrObj: entidad.caracteristicas, dato: 'img'})
        entidad.caracteristicas = arr

        nuevoAviso({aviso: 'Subiendo datos'})
        let result = await guardarDoc('habitaciones', entidad)
        await guardarFechaAct('habitaciones')
        if (result.res) {
            terminar({aviso: 'Datos subidos correctamente'})
        } else {
            terminar({aviso: 'Algo inesperado paso! datos no subidos', variante: 'error'})
        }


    }


    const borrar = async () => {
        await borrarDoc('habitaciones', datos.id)
        terminar({aviso: 'Registro borrado'})
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Habitaciones_Detalles props={props}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Habitaciones_Detalles